<div class="modal-header">
    <incident-dialog-header [incident]="data.incident" (close)="cancel()"></incident-dialog-header>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="(null != validationResults) && (null != validationResults.validationResults) && (0 != validationResults.validationResults.length)"></validation-results>
    <h2 class="btn--h2-hack"><button class="icon--download btn--default" type="button" title="Last Reevaluated by: {{ this.lastReevaluatedBy }}" *ngIf="data.incident.incidentNumberId > 0" (click)="reevaluateAndUpdateProhibition(data.incident.incidentNumberId)">Reevaluate Incident</button></h2>
    <incident-dialog-content [parent]="this" [fieldsTemplate]="fieldsTemplate" [formGroup]="incidentForm" (occurrenceDateBlur)="occurrenceDateBlur($event)" (occurrenceDateChanged)="occurrenceDateChanged($event)">
        <ng-template #fieldsTemplate>
            <div class="col-sm-4 mvd_form-group">
                <label class="required" title="* Required">Land Type Location</label>
                <select class="mvd_form-control" formControlName="landCategoryTypeId" (change)="onLandChange($event.target.value)">
                    <option>Select</option>
                    <option *ngFor="let item of landCategories" value="{{ item.landCategoryTypeId }}">{{ item.landCategoryTypeDisplayValue }}</option>
                </select>
            </div>
            <div class="col-sm-8 mvd_form-group">
                <label class="required" title="* Required">VIN</label>
                <input class="mvd_form-control" formControlName="vin" (change)="onVinChange($event.target.value)" />
                <control-validation-messages control="vin"></control-validation-messages>
            </div>
        </ng-template>
    </incident-dialog-content>

    <h2>Customer</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <customer-search-bar id="incidentCustomerSearch" #customerSearchBar [label]="'Add Customer'" (onItemSelected)="addCustomer($event)" *ngIf="!data.isReadOnly"></customer-search-bar>
            </div>
        </div>
        <label>Existing Customer(s)</label>
        <div class="search--omni" *ngFor="let customer of data.incident.customers">
            <ul>
                <li class="search--omni__image">
                    <customer-photo [classes]="'mvd_photo'" [customerNumberId]="customer.id" [legacySequenceNumber]="customer.legacySequenceNumber"></customer-photo>
                </li>
                <li>
                    <div><b>{{ customer.firstName }} {{ customer.middleName }} {{ customer.lastName }}</b></div>
                    <div>{{ customer | address }}</div>
                </li>
                <li class="search--omni__remove">
                    <a class="icon--remove" title="Remove" href="javascript:void(0)" (click)="confirmRemoveCustomer(customer)" *ngIf="!data.isReadOnly"></a>
                </li>
            </ul>
        </div>
    </fieldset>
    <incident-updated [updatedBy]="data.incident.updatedBy" [updatedDate]="data.incident.updatedDate"></incident-updated>
</div>
<div class="modal-footer">
    <incident-dialog-footer [incident]="data.incident" [isReadOnly]="data.isReadOnly" [isDisabled]="!incidentForm.valid" [isLoading]="showButtonLoading" (cancel)="cancel()" (save)="saveIncident()"></incident-dialog-footer>
</div>
